import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import ContactsPage from './pages/ContactsPage';
import CreateUser from './pages/CreateUser';
import UserTable from './components/UserTable';
import Sidebar from './components/Sidebar';
import TopNavbar from './components/Navbar';
import { UserProvider } from './context/UserContext';
//import { useEffect, useState, ReactNode  } from 'react';
import PrivateRoute from './components/PrivateRoute';
import ClustersPageGoogleMaps from "./pages/ClustersPageGoogleMaps";
import GeoDashboard from './pages/GeoDashboard';
import ContactsGeolocationPage from './pages/ContactsGeolocationPage';
import BusquedaActividadPage from './pages/BusquedaActividadPage';
import ClusterPage from './pages/ClusterPage';
import ContactsSelectedPage from './pages/ContactsSelectedPage';
import WelcomePage from './pages/WelcomePage';

// ✅ Layout separado
function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="d-flex">
      <Sidebar />
      <div className="flex-grow-1">
        <TopNavbar />
        <div className="p-3">{children}</div>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter basename="/contactos">
      <UserProvider>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />

          <Route
            path="/welcome"
            element={
              <Layout>
                <WelcomePage />
              </Layout>
            }
          />

          <Route
            path="/contacts"
            element={
              <PrivateRoute allowedRoles={["admin", "viewer"]}>
                <Layout>
                  <ContactsPage />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/usuarios"
            element={
              <PrivateRoute allowedRoles={["admin"]}>
                <Layout>
                  <UserTable />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/create-user"
            element={
              <PrivateRoute allowedRoles={["admin"]}>
                <Layout>
                  <CreateUser />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/clusters"
            element={
              <PrivateRoute allowedRoles={["admin", "clusters"]}>
                <Layout>
                  <ClusterPage />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/geo"
            element={
              <PrivateRoute allowedRoles={["admin", "clusters"]}>
                <Layout>
                  <GeoDashboard />
                </Layout>
              </PrivateRoute>
            }
          />

          <Route
            path="/locate-contacts"
            element={
              <PrivateRoute allowedRoles={["admin", "clusters"]}>
                <Layout>
                  <ContactsGeolocationPage />
                </Layout>
              </PrivateRoute>
            }
          /> 

         <Route
            path="/select-contacts"
            element={
              <PrivateRoute allowedRoles={["admin", "viewer", "search"]}>
                <Layout>
                  <ContactsSelectedPage />
                </Layout>
              </PrivateRoute>
            }
          /> 

          <Route
            path="/ciiu-contacts"
            element={
              <PrivateRoute allowedRoles={["admin"]}>
                <Layout>
                  <BusquedaActividadPage />
                </Layout>
              </PrivateRoute>
            }
          />

        </Routes>
      </UserProvider>
    </BrowserRouter>
  );
}

export default App;